import React from 'react'
import Helmet from 'react-helmet'

import PageHeader from '../components/PageHeader'
import Link from '../components/Link'

// temporary hosting this on Snips.ai
export default function PrivacyPolicyDataGen () {
  return (
    <main className='main terms-of-sale-page maxw-xxlarge mx-auto'>
      <Helmet meta={[{ name: 'robots', content: 'noindex' }]} />
      <PageHeader
        extraClass='top-rounded'
        title={<span className='h3'>Privacy Policy for Workers</span>}
      >
        <hr className='hr--grey  maxw-medium mb2 mx-auto' />
        <p className='text-para small'>Last updated: September 27th, 2018</p>
      </PageHeader>
      <div className='bg-white bottom-rounded mb2'>
        <div className='col-11 maxw-medium mx-auto'>
          <div className='pb4'>
            <p>
              Snips is a voice interface software company using the latest
              techniques in machine learning to create voice interfaces allowing
              human interaction with hardware devices whilst safeguarding users’
              privacy. The data generation tasks you perform help Snips gather
              enough data to be able to train its machine learning algorithms to
              recognise voice commands accurately and transcribe them into
              machine-understandable orders.
            </p>
            <p className='mb3'>
              To learn more about Snips’ technology, visit Snips’ website at{' '}
              <Link href='https://snips.ai' target='_blank'>
                snips.ai
              </Link>.
            </p>
            <h2 className='h4 mb2'>
              Why does Snips need your personal information?
            </h2>
            <p>
              Snips needs your worker ID in order to be able to contact you and
              keep track of the fact that you performed the task it requested on
              a crowdsourcing platform. Where the task involves recording your
              voice, Snips also needs demographic data (age, gender, and
              country) in order to be able to classify and use the voice
              recordings for machine learning purposes. The legal basis for the
              processing of your personal data for that purpose is the
              conclusion and performance of the contract between you and Snips,
              consisting in your undertaking to perform the requested task for
              the proposed payment.
            </p>
            <p>
              In addition, because Snips believes in the power of open source
              and making resources available for researchers, Snips may also use
              your voice recordings for scientific research purposes or to
              contribute to open source projects. This may involve open sourcing
              these recordings for use by a wider community. We will never
              reveal your worker ID or identity, but we may share your
              demographic data as it will help other researchers make use of
              your voice data. The basis for this processing is Snips’ and other
              researchers’ legitimate interest in improving machine learning
              research and development through open sourcing data sets.
            </p>
            <p>
              Unless any of the above information is marked as optional at the
              time of collection, it is required in order to be able to complete
              your task. Please do not complete a task for Snips if you do not
              wish us to collect and use your personal data in the way described
              above.
            </p>
            <p>
              We may share your demographic information and voice recordings
              with our customers who requested the data sets to create voice
              assistants customized for their purposes, service providers who
              may be involved in building our technology, as well as with the
              global community of machine learning researchers. We may also
              share your information with competent regulatory or other
              authorities for legitimate reasons. If this involves your data
              being stored or accessed from outside of the EU, we will make sure
              we implement adequate measures to secure the data transfer, such
              as a data transfer agreement based on the EU Commission’s model
              clauses.
            </p>
            <p className='mb3'>
              We will store your information for as long as it remains useful
              and relevant for the purpose of developing our machine learning
              technology or for scientific research.
            </p>
            <h2 className='h4 mb2'>What rights do you have?</h2>
            <p className='mb3'>
              You have the right to request access to, rectification or erasure
              of your personal data or the restriction of the processing of your
              personal data, or to object to the processing, as well as the
              right to data portability, under the conditions laid out in the
              GDPR. You also have the right to lodge a complaint with a
              supervisory authority, and to give us instructions on how to
              handle your personal data in the event of your death.
            </p>
            <h2 className='h4 mb2'>Contact Us</h2>
            <p>
              For more information or to exercise your rights, please contact
              our team at{' '}
              <Link href='https://snips.ai/contact' target='_blank'>
                snips.ai/contact
              </Link>.
            </p>
          </div>
        </div>
      </div>
    </main>
  )
}



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/PrivacyPolicyDataGenPage.js